module.exports = __webpack_public_path__ + "img/Visa.17821423.svg";